module.exports = __webpack_public_path__ + "img/click-for-price-grid-button.77190d2b.gif";